import { Component, Input, ViewEncapsulation } from '@angular/core';
import { TlkModalWindowService } from '@itero/ui-toolkit-angular/modal-window';
import { Observable } from 'rxjs';
import { LoggerService } from '@core/services/logger/logger.service';
import { AwarenessFacade } from '@modules/awareness/awareness.facade';
import { AwarenessMiniPopupComponent, AwarenessMiniPopupData } from '../awareness-mini-popup/awareness-mini-popup.component';

@Component({
	selector: 'rx-awareness-banner',
	templateUrl: './awareness-banner.component.html',
	styleUrls: ['./awareness-banner.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class AwarenessBannerComponent {
	private static componentName = 'AwarenessBannerComponent';

	@Input() showBannerButton = true;
	@Input() qrName = '';
	@Input() flat = false;

	linkToTheLearningCenter$ = this.awarenessFacade.linkToTheLearningCenter$;
	showLearningCenterPart$ = this.awarenessFacade.showLearningCenterPart$;
	shouldNotifyCompanyByEmail$ = this.awarenessFacade.shouldNotifyCompanyByEmail$;

	constructor(private readonly modalService: TlkModalWindowService, private readonly loggerService: LoggerService, private readonly awarenessFacade: AwarenessFacade) {}

	openPopup(): Observable<unknown> {
		this.loggerService.info(`Awareness QR was opened from banner, when procedure flow is ${String(this.isProcedureFlow)}`, {
			module: AwarenessBannerComponent.componentName
		});

		const data: AwarenessMiniPopupData = {
			shouldNotifyCompanyByEmail$: this.shouldNotifyCompanyByEmail$,
			showLearningCenterPart$: this.showLearningCenterPart$,
			linkToTheLearningCenter$: this.linkToTheLearningCenter$
		};

		return this.modalService.open(AwarenessMiniPopupComponent, { data }).closed;
	}

	get isProcedureFlow(): boolean {
		return this.awarenessFacade.isProcedureFlow;
	}
}
